export enum OrganizationSubscriptionStatus {
  Active = 'Active',
  Deleted = 'Deleted',
  Expired = 'Expired',
  New = 'New',
  Draft = 'Draft',
}
